var map = {
	"./Autodromo Nazionale di Monza.png": 9698,
	"./Autódromo Hermanos Rodríguez.jpg": 4685,
	"./Autódromo José Carlos Pace.jpg": 7317,
	"./Bahrain International Circuit.jpg": 4261,
	"./Baku City Circuit.avif": 449,
	"./Circuit Park Zandvoort.jpg": 2381,
	"./Circuit de Barcelona-Catalunya.jpg": 7125,
	"./Circuit de Monaco.jpg": 7676,
	"./Circuit de Spa-Francorchamps.webp": 5444,
	"./Circuit of the Americas.jpg": 9791,
	"./Hungaroring.jpg": 5913,
	"./Las Vegas Grand Prix.jpg": 566,
	"./Losail International Circuit.jpeg": 8899,
	"./Marina Bay Street Circuit.jpg": 1245,
	"./Miami International Autodrome.avif": 8621,
	"./Red Bull Ring Austria.webp": 5265,
	"./Shanghai International Circuit.webp": 7506,
	"./Silverstone Circuit.jpg": 5804,
	"./Spanish Grand Prix.jpg": 2236,
	"./Suzuka Circuit Japan.webp": 8734,
	"./Yas Marina Circuit.avif": 6818,
	"./albert-park-gp-circuit-1.jpg": 5606,
	"./circuit-gilles-villeneuve.jpg": 8507,
	"./circuito-bahrain-f1-1.jpeg": 2368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1909;